import * as XLSX from "xlsx";
import type { NewProduct } from "@/hooks/useNewProducts";

export function exportNewProductsToExcel(products: NewProduct[], filename?: string) {
  // Define column headers in Dutch
  const headers = [
    "Product Naam",
    "Artikelnummer",
    "Barcode",
    "Eenheid",
    "Locatie",
    "Voorraad",
    "MOQ",
    "Gewicht (kg)",
    "Eerste Detectie",
    "Status",
  ];

  // Transform data for Excel
  const excelData = products.map((product) => ({
    "Product Naam": product.product_naam || "",
    "Artikelnummer": product.product_id,
    "Barcode": product.bc || "",
    "Eenheid": product.eenheid || "",
    "Locatie": product.locatie || "",
    "Voorraad": product.voorraad,
    "MOQ": product.moq || "",
    "Gewicht (kg)": product.vrije_waarde_2 || "",
    "Eerste Detectie": formatDate(product.first_seen_at),
    "Status": product.hidden ? "Verborgen" : "Actief",
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData, { header: headers });

  // Set column widths
  worksheet["!cols"] = [
    { wch: 40 }, // Product Naam
    { wch: 15 }, // Artikelnummer
    { wch: 15 }, // Barcode
    { wch: 10 }, // Eenheid
    { wch: 15 }, // Locatie
    { wch: 10 }, // Voorraad
    { wch: 8 },  // MOQ
    { wch: 12 }, // Gewicht
    { wch: 18 }, // Eerste Detectie
    { wch: 10 }, // Status
  ];

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Nieuwe Producten");

  // Generate filename with date
  const dateStr = new Date().toISOString().split("T")[0];
  const exportFilename = filename || `nieuwe-producten-magazijn2-${dateStr}.xlsx`;

  // Trigger download
  XLSX.writeFile(workbook, exportFilename);
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString("nl-NL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
